import color, { GetColorList, GetColorOptions } from 'atoms/colors/colors';

import { keyExistsOnObject, objectEntries, valueof } from 'utils/typeUtils';

import type { Properties } from 'csstype';
import type { DefaultTheme } from 'styled-components';

export const gradient = {
  gray: {
    '600a': `conic-gradient(from 259.08deg at 50% 50%, ${color.gray[700]} 0deg, ${color.gray[700]}00 360deg)`,
    '600500a': `linear-gradient(90deg, ${color.gray[700]} 0%, ${color.gray[400]} 100%)`,
    '700600a': `linear-gradient(45deg, ${color.gray[700]} 0%, ${color.gray[700]} 100%)`,
    '800600a': `linear-gradient(45deg, ${color.gray[900]} 0%, ${color.gray[700]} 100%)`,
    '800600b': `linear-gradient(63.44deg, ${color.gray[900]} 16.72%, ${color.gray[700]} 83.39%)`,
    '800700a': `linear-gradient(26.57deg, ${color.gray[900]} 8.33%, ${color.gray[700]} 91.67%)`,
    '900600a': `linear-gradient(45deg, ${color.gray[900]} 0%, ${color.gray[700]} 100%)`,
  },
  primary: {
    '600a': 'linear-gradient(45deg, #00AECF 0%, #66C4AB 100%);',
  },
} as const;

export type GradientObject = typeof gradient;
export type GradientOptions = GetColorOptions<GradientObject>;

export type GradientList = GetColorList<GradientObject> | undefined;
export type GradientDefinition = keyof GradientObject;
export const gradientListArray = objectEntries(gradient)
  .map(([gradientName, gradientValues]) => Object.keys(gradientValues).map(value => `${gradientName}-${value}`))
  .flat() as GradientList[];

export interface LightAndDark {
  light: GradientList;
  dark: GradientList;
}

type GradientKeys = valueof<GradientOptions>;
type GradientArray = [GradientDefinition, GradientKeys];

export type GetGradientDefinition = GradientList | LightAndDark;

export const getGradient = (palette: DefaultTheme['palette'], gradients: GetGradientDefinition) => {
  if (!gradients) {
    return;
  }

  return typeof gradients === 'object' ? gradients[palette.mode] : gradients;
};

/**
 * @param value any string
 * @returns if string is valid gradient atom, returns `gradient`. if not, `url(inputString)`
 */
export const parseBackgroundGradient = (
  palette: DefaultTheme['palette'],
  value: GetGradientDefinition | Properties['backgroundImage'],
) => {
  const parsedValue = getGradient(palette, value as GetGradientDefinition);
  const [gradientName, gradientValue] = parsedValue?.split('-') as GradientArray;

  if (!keyExistsOnObject(gradient, gradientName) || !keyExistsOnObject(gradient[gradientName], gradientValue)) {
    return `url(${value})`;
  }

  return gradient[gradientName][gradientValue];
};

export default gradient;
